const defaultMeta = {
  requiresAuth: true,
  requiresAdmin: false,
}

export default {
  path: '/account',
  name: 'user-account',
  meta: defaultMeta,
  component: _ => import('@/views/UserAccountView.vue'),
  props: true,
  redirect: {
    name: 'user-account-profile',
  },
  children: [
    {
      path: 'profile',
      name: 'user-account-profile',
      meta: {
        ...defaultMeta,
        title: 'User Profile',
      },
      props: true,
      component: _ => import('@/components/UserAccount/UserProfile.vue'),
    },
    {
      path: 'contacts',
      name: 'user-account-contact-details',
      meta: {
        ...defaultMeta,
        title: 'Contact Details',
      },
      props: true,
      component: _ => import('@/components/UserAccount/ContactDetails.vue'),
    },
    {
      path: 'integrations',
      name: 'user-account-integration-settings',
      meta: {
        ...defaultMeta,
        title: 'Integration Settings',
      },
      props: true,
      component: _ => import('@/components/UserAccount/IntegrationSettings.vue'),
    },
    {
      path: 'security',
      name: 'user-account-security-settings',
      meta: {
        ...defaultMeta,
        title: 'Security Settings',
      },
      props: true,
      component: _ => import('@/components/UserAccount/SecuritySettings.vue'),
    },
  ],
}
